module.exports = __webpack_public_path__ + "static/media/image1.48480941.png";